const Loader = () => {
  return(
    <div className="bouncer-body">
      <div className="bouncer">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
export default Loader;
